// src/pages/AuthPage.js
import React, { useState } from 'react';
import Login from '../components/Login';
import SignUp from '../components/SignUp';

const AuthPage = () => {
  const [showLogin, setShowLogin] = useState(true);

  // This function will be passed to Login and SignUp
  const toggleForm = (e) => {
    e.preventDefault(); // Prevent the link's default behavior
    setShowLogin(!showLogin);
  };

  return (
    <div>
      {showLogin ? (
        <Login onToggle={toggleForm} />
      ) : (
        <SignUp onToggle={toggleForm} />
      )}
    </div>
  );
};

export default AuthPage;